module.exports = __webpack_public_path__ + "img/quick-menu.ee918068.png";